import { Breadcrumbs } from 'ui'
import CartAddAnotherProduct from '@/components/cart/CartAddAnotherProduct'

export default function CartHeader() {
	return (
		<div className="flex flex-row justify-between items-center">
			<Breadcrumbs
				items={[
					{ title: 'Home', slug: '/' },
					{ title: 'Cart', slug: 'cart' }
				]}
			/>
			<CartAddAnotherProduct />
		</div>
	)
}
